module.exports = __webpack_public_path__ + "OpenSans-Semibold.9f2144213fad53d4e0fd.woff";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/node_modules/npm-font-open-sans/fonts/Semibold/OpenSans-Semibold.woff
// module id = ../../../../npm-font-open-sans/fonts/Semibold/OpenSans-Semibold.woff
// module chunks = styles